import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Print Icon Component
 * Printer icon for print services
 * Used in print upsell feature
 */
class PrintIcon extends BaseIcon {
    constructor() {
        super();
        this.size = 6; // Default: h-6 w-6 (24px)
    }

    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        // Lucide printer icon paths
        return svg`
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
        `;
    }
}

customElements.define('print-icon', PrintIcon);
